/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportPowerbiEmbedDetails {
    getFixupPrototypeFunction() { return ReportPowerbiEmbedDetails.fixupPrototype; }

    static newInstance(model: Partial<ReportPowerbiEmbedDetails>): ReportPowerbiEmbedDetails {
        let obj = Object.assign(new ReportPowerbiEmbedDetails(), model);
        ReportPowerbiEmbedDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportPowerbiEmbedDetails>): ReportPowerbiEmbedDetails {
        if (!model) return null;
        return ReportPowerbiEmbedDetails.newInstance(<ReportPowerbiEmbedDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportPowerbiEmbedDetails) {
        if (!obj) return;

        models.ReportPowerbiEmbedDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportPowerbiEmbedDetails): boolean {
        Object.setPrototypeOf(obj, ReportPowerbiEmbedDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Power BI embed URL for the report or dashboard
     */
    embed_url: string;

    /**
     * Short-lived Power BI embed token for the embed URL
     */
    embed_token: string;

    /**
     * Power BI id of the embedded report or dashboard
     */
    powerbi_report_id: string;

    /**
     * Kind of Power BI item to embed
     */
    embed_type: models.ReportPowerbiEmbedType;

}
